module.exports = __webpack_public_path__ + "img/play.a4e927cf.png";